import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Container, Row, Form, Button, InputGroup } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { commonService } from "../../utils/commonService";
import { API_URL } from "../../utils/apiRoutes";
import { apiCall } from "../../utils/axiosService";
import { apiResponse } from "../../utils/apiResponse";
import userPlaceHolder from "../../Assets/Images/blank-user.svg";
import Loader from "../Loader/Loader";
import { errorToastMessage, successToastMessage } from "../../utils/toastMessage";

function MultiUserSelection() {
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const [login, setLogin] = useState(false);
    const [TxtSearch, SetTxtSearch] = useState("");
    let redirect = "";
    let mod = "";
    let p = "";

    if (searchParams.has('redirect')) {
        redirect = searchParams.get('redirect');
    }

    if (searchParams.has('mod')) {
        mod = searchParams.get('mod');
    }

    if (searchParams.has('p')) {
        p = searchParams.get('p');
    }

    const [MultiUserData, setMultiUserData] = useState([]);

    let sid = commonService.getItem("sid");

    useEffect(() => {
        setLogin(true);
        let dataStr = commonService.getItem("MultiUserDetails");
        if (dataStr !== "") {
            var data = JSON.parse(dataStr);
            if (data && data.length > 0) {
                if (data.length === 1) {
                    loginById(data[0].sid, data[0])
                }
                else {
                    setMultiUserData(data)
                    setLogin(false);
                }
            }
            else {
                setLogin(false);
                commonService.LogOutToUser()
            }
        }
        else {
            setLogin(false);
            commonService.LogOutToUser()
        }
    }, []);

    useEffect(() => {
        let dataStr = commonService.getItem("MultiUserDetails");
        if (dataStr !== "") {
            var data = JSON.parse(dataStr);
            if (data && data.length > 0) {
                if (TxtSearch) {
                    let search = data.filter((d) => d.cn.toUpperCase().indexOf(TxtSearch.toUpperCase()) >= 0);
                    setMultiUserData(search)
                }
                else {
                    setMultiUserData(data)
                }
            }
        }
    }, [TxtSearch]);




    const loginById = async (id, data) => {
        setLogin(true);
        commonService.fnSetMainAndSubDomain();
        if (data) {
            if (data.isas === 0) {
                setLogin(false);
                navigate("/agreementrequired");
                return false;
            }
        }

        commonService.setItem("sid", id);
        let loginResponse = await apiCall(
            {
                method: "POST",
                url: `${API_URL.BASE_API_URL.UserManagement + API_URL.CLIENT_USER_LOGIN_BY_ID
                    }?userid=${id}`,
            },
            false
        );

        let response = apiResponse(false, loginResponse);

        if (response?.isValidate) {

            commonService.setItem("token", response?.data?.data?.token);
            commonService.setItem("ntoken", response?.data?.data?.ntoken);
            commonService.setItem(
                "userDetail",
                JSON.stringify(response?.data?.data?.userdata?.[0])
            );
            commonService.setItem(
                "userRights",
                JSON.stringify({
                    userrole: response?.data?.data?.userrole,
                    userpropertyrole: response?.data?.data?.userpropertyrole,
                    usermodule: response?.data?.data?.usermodule,
                })
            );
            commonService.setItemWithoutCrypto("tokenid", response?.data?.data?.tokenid);

            let response1 = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.UserManagement + API_URL.LOGINSWITCHSET,
                    body: {
                        t: commonService.getItemWithoutCrypto("token"),
                        ud: commonService.getItemWithoutCrypto("userDetail"),
                        ur: commonService.getItemWithoutCrypto("userRights"),
                        tokenid: commonService.getItemWithoutCrypto("tokenid"),
                        nt: commonService.getItemWithoutCrypto("ntoken"),
                    },
                },
                true
            );

            setLogin(false);

            if (redirect !== null && redirect !== undefined && redirect !== "" && p !== null && p !== undefined && p !== "" && mod !== null && mod !== undefined && mod !== "") {
                navigate("/dashboard?redirect=" + redirect + "&mod=" + mod + "&p=" + p);
                return;
            }
            else {
                navigate("/dashboard");
            }
        }
        else {
            setLogin(false);
            errorToastMessage(response?.message);
        }
    };

    return (
        <div className="new-sign-in-page-main">
            <Container>
                <Row className="login-main-inner">
                    <Col xl={12}>
                        <div className="login-right">
                            <div className="login-right-main">

                                {
                                    login ? <Loader /> :
                                        <>
                                            <Form.Control id={commonService.generateGlobalClickTrackerID("MutltiUserSelection", "search", "")}
                                                type="text"
                                                placeholder="Search Here..."
                                                value={TxtSearch}
                                                onChange={(e) =>
                                                    SetTxtSearch(e.target.value)
                                                }
                                                className="mb-3"
                                            />

                                            <div class="three-grid-section">

                                                {
                                                    MultiUserData && MultiUserData.length > 0 &&
                                                    <>
                                                        {
                                                            MultiUserData.map((u) => {
                                                                return (
                                                                    <div class="switchaccount-select-user mt-4 cursorPointer" data-id={u.id} data-cid={u.subid} onClick={(e) => loginById(u.sid, u)}>
                                                                        <div className={`image-area-popup ${u.sid === sid ? "active" : ""
                                                                            }`}>
                                                                            <img src={u?.profilepic
                                                                                ? u?.profilepic
                                                                                : userPlaceHolder} alt="" />
                                                                        </div>
                                                                        <div class="text-area-popup">
                                                                            <p class="name-popup" title={u.dn}>{u.dn}</p>
                                                                            <p class="client-popup" title={u.cn}>{u.cn}</p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                }</div>
                                        </>
                                }


                                <h5 className="text-center switchaccount-logout cursorPointer" onClick={(e) => commonService.LogOutToUser()}> LOGOUT</h5>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

        </div>
    );
}

export default MultiUserSelection;
